import { Component, Vue } from 'vue-property-decorator'

@Component
class AnalyticsMixin extends Vue {
    sendScreenView(screenName: string, key1: string | null = null, key2: string | null = null) {
        if (this.isAnalyticsEnabled()) {
            try {
                this.$store.dispatch("saveScreenNameData", screenName);
                (this.$gtag as any).screenview({
                    'app_name': 'Web',
                    'screen_name': screenName,
                    'dimension8': key1,
                    'dimension9': key2
                } as any);
                this.$analytics.hitCounter();
            }
            catch (e) {
                e['ga'] = true;
                this.$store.dispatch('reportError', e);
            }
        }
    }

    sendTrackingEvent() {
        if (this.isAnalyticsEnabled()) {
            try {
                this.$gtag.event('track', {'event_category': 'Page Visibility'});
                this.$analytics.hitCounter();
            }
            catch (e) {
                e['ga'] = true;
                this.$store.dispatch('reportError', e);
            }
        }
    }

    isAnalyticsEnabled() {
        return !!this.$store.getters['services/getServiceParam']('googleAnalytics', 'trackingId');
    }

    setEventId(id: string) {
        try {
            this.$gtag.set({
                'dimension7': id
            });
        }
        catch(e) {
            this.$store.dispatch('reportException', e)
        }

    }
}

export default AnalyticsMixin;